var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticStyle: { "margin-top": "5px" } }, [
        _c(
          "div",
          {
            staticStyle: {
              "margin-bottom": "20px",
              position: "relative",
              "z-index": "1",
              display: "inline-block",
            },
          },
          [
            _c("el-date-picker", {
              staticClass: "input-common",
              staticStyle: { width: "115px" },
              attrs: {
                clearable: false,
                type: "month",
                "value-format": "yyyy-MM-dd",
                format: "MM-yyyy",
              },
              on: {
                change: function ($event) {
                  return _vm.searchKidsPackageByProperties()
                },
              },
              model: {
                value: _vm.dataSearch.date,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "date", $$v)
                },
                expression: "dataSearch.date",
              },
            }),
            _c(
              "el-select",
              {
                staticClass: "input-common",
                staticStyle: { width: "140px" },
                attrs: { placeholder: "Trạng thái" },
                on: {
                  change: function ($event) {
                    return _vm.searchKidsPackageByProperties()
                  },
                },
                model: {
                  value: _vm.dataSearch.status,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "status", $$v)
                  },
                  expression: "dataSearch.status",
                },
              },
              _vm._l(_vm.kidStatusList, function (item) {
                return _c("el-option", {
                  key: item.key,
                  attrs: { value: item.key, label: item.value },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "input-common input-grade",
                staticStyle: { width: "140px" },
                attrs: { disabled: _vm.loadingData, placeholder: "Chọn khối" },
                on: {
                  change: function ($event) {
                    return _vm.changeGradeSearch()
                  },
                },
                model: {
                  value: _vm.dataSearch.idGrade,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "idGrade", $$v)
                  },
                  expression: "dataSearch.idGrade",
                },
              },
              _vm._l(_vm.gradeOfSchoolList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { value: item.id, label: item.gradeName },
                })
              }),
              1
            ),
            _c(
              "el-select",
              {
                staticClass: "input-common input-class",
                staticStyle: { width: "140px" },
                attrs: { placeholder: "Chọn lớp", disabled: _vm.loadingData },
                on: {
                  change: function ($event) {
                    return _vm.searchKidsPackageByProperties()
                  },
                },
                model: {
                  value: _vm.dataSearch.idClass,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "idClass", $$v)
                  },
                  expression: "dataSearch.idClass",
                },
              },
              _vm._l(_vm.classList, function (item) {
                return _c("el-option", {
                  key: item.id,
                  attrs: { value: item.id, label: item.className },
                })
              }),
              1
            ),
            _c(
              "el-input",
              {
                staticStyle: { width: "220px" },
                attrs: { placeholder: "Nhập tên học sinh", clearable: "" },
                on: {
                  clear: function ($event) {
                    return _vm.searchKidsPackageByProperties()
                  },
                },
                nativeOn: {
                  keyup: function ($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.searchKidsPackageByProperties()
                  },
                },
                model: {
                  value: _vm.dataSearch.fullName,
                  callback: function ($$v) {
                    _vm.$set(_vm.dataSearch, "fullName", $$v)
                  },
                  expression: "dataSearch.fullName",
                },
              },
              [
                _c("el-button", {
                  attrs: { slot: "append", icon: "el-icon-search" },
                  on: {
                    click: function ($event) {
                      return _vm.searchKidsPackageByProperties()
                    },
                  },
                  slot: "append",
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { float: "right", display: "flex" } },
          [
            _c(
              "el-button",
              {
                staticStyle: { "border-radius": "0", "margin-right": "5px" },
                attrs: { type: "success" },
                on: {
                  click: function ($event) {
                    return _vm.searchKidsPackageByProperties()
                  },
                },
              },
              [_vm._v("\n        Cập nhật dữ liệu\n      ")]
            ),
            _vm.checkPermission(["fees_approved_approved"]) ||
            _vm.checkPermission(["fees_approved_locked"]) ||
            _vm.checkPermission(["fees_approved_useNumber"])
              ? _c(
                  "div",
                  [
                    _vm.dataSearch.idClass > 0
                      ? _c(
                          "el-button",
                          {
                            staticStyle: { "border-radius": "0" },
                            attrs: { type: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.approvedRapidMethod()
                              },
                            },
                          },
                          [_vm._v("\n          Cập nhật nhanh\n        ")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "table-content row-data" },
          [
            _c(
              "el-table",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingData,
                    expression: "loadingData",
                  },
                ],
                ref: "kidsPackageForKidsRef",
                attrs: {
                  data: _vm.responseDataList,
                  "empty-text": _vm.textTable,
                  "element-loading-text": _vm.$tableLoading,
                  "element-loading-spinner": "el-icon-loading",
                  "element-loading-background": "rgba(255,255,255, 0)",
                  "cell-style": _vm.tableRowStyle,
                  "header-cell-style": _vm.tableHeaderColor,
                  "max-height": _vm.$tableMaxHeight,
                  border: "",
                },
                on: { "selection-change": _vm.handleSelectionChange },
              },
              [
                _c("el-table-column", {
                  attrs: { type: "expand", width: "1" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c(
                            "div",
                            { staticStyle: { margin: "0 15px 10px 15px" } },
                            [
                              _c(
                                "el-table",
                                {
                                  directives: [
                                    {
                                      name: "loading",
                                      rawName: "v-loading",
                                      value: _vm.loadingDataChildren,
                                      expression: "loadingDataChildren",
                                    },
                                  ],
                                  ref: "kidsPackageForKidsRef1",
                                  attrs: {
                                    data: scope.row.fnKidsPackageList,
                                    "empty-text": _vm.textTable,
                                    "element-loading-text": _vm.$tableLoading,
                                    "element-loading-spinner":
                                      "el-icon-loading",
                                    "element-loading-background":
                                      "rgba(255,255,255, 0)",
                                    "highlight-current-row": "",
                                    "cell-style": _vm.tableRowStyleChildren,
                                    "header-cell-style":
                                      _vm.tableHeaderChidrenColor,
                                    "max-height": _vm.$tableMaxHeightSmall,
                                    border: "",
                                  },
                                  on: {
                                    "selection-change":
                                      _vm.handleSelectionChange,
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: {
                                      fixed: "",
                                      type: "index",
                                      label: "STT",
                                      width: "50",
                                      align: "center",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      fixed: "",
                                      label: "Tên khoản",
                                      prop: "fnPackage.name",
                                      "min-width": "150",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      fixed: "",
                                      label: "Trạng thái",
                                      align: "center",
                                      width: "95",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.approved
                                                ? _c("span", [
                                                    scope.row.usedNumber == 0 ||
                                                    (scope.row.paid == 0 &&
                                                      scope.row.money > 0)
                                                      ? _c("span", [
                                                          _vm._v("Chưa đóng"),
                                                        ])
                                                      : scope.row.paid <
                                                        scope.row.money
                                                      ? _c("span", [
                                                          _vm._v("Thiếu"),
                                                        ])
                                                      : _c("span", [
                                                          _vm._v("Đủ"),
                                                        ]),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Kiểu đóng",
                                      align: "center",
                                      width: "90",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.fnPackage.type ==
                                              "single"
                                                ? _c("span", [
                                                    _vm._v("Một lần"),
                                                  ])
                                                : scope.row.fnPackage.type ==
                                                  "multiple"
                                                ? _c("span", [
                                                    _vm._v("Nhiều lần"),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Đính kèm",
                                      align: "center",
                                      width: "90",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return scope.row
                                              .fnPackageKidsExtend != null
                                              ? [
                                                  _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content:
                                                          "Khoản đính kèm: " +
                                                          scope.row
                                                            .fnPackageKidsExtend
                                                            .name,
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      _c("i", {
                                                        staticClass:
                                                          "el-icon-circle-check",
                                                        style: scope.row
                                                          .fnPackageKidsExtend
                                                          .active
                                                          ? "margin-left: 10px; color: #409eff"
                                                          : "margin-left: 10px; color: red",
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              : undefined
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "Loại",
                                      width: "80",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.fnPackage.category ==
                                              "in"
                                                ? _c("span", [_vm._v("Thu")])
                                                : scope.row.fnPackage
                                                    .category == "out"
                                                ? _c("span", [_vm._v("Chi")])
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "number",
                                      align: "center",
                                      label: "Số lượng",
                                      width: "80",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "right",
                                      label: "Đơn giá",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatCurrencyNew")(
                                                      scope.row.price
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "discount",
                                      align: "center",
                                      label: "Giảm giá",
                                      width: "80",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.discount
                                                ? _c("span", [_vm._v("Có")])
                                                : _c("span", [_vm._v("Không")]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "discountPrice",
                                      align: "right",
                                      label: "Đơn giá sau giảm",
                                      width: "120",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.discount
                                                ? _c("span", [
                                                    _c("span", [
                                                      _vm._v(
                                                        "\n                        " +
                                                          _vm._s(
                                                            _vm._f(
                                                              "formatCurrencyNew"
                                                            )(
                                                              scope.row
                                                                .discountPrice
                                                            )
                                                          )
                                                      ),
                                                    ]),
                                                  ])
                                                : _c("span", [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f(
                                                            "formatCurrencyNew"
                                                          )(scope.row.price)
                                                        )
                                                      ),
                                                    ]),
                                                  ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      align: "center",
                                      label: "Điểm danh",
                                      width: "90",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.fnPackage.attendance
                                                ? _c("span", [_vm._v("Có")])
                                                : _c("span", [_vm._v("Không")]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "calculateNumber",
                                      align: "center",
                                      label: "Số dự toán",
                                      width: "90",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Tiền dự toán",
                                      align: "right",
                                      width: "110",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatCurrencyNew")(
                                                      scope.row.moneyTemp
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "usedNumber",
                                      align: "center",
                                      label: "Số sử dụng",
                                      width: "100",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.approved ||
                                              scope.row.locked ||
                                              !_vm.checkPermission([
                                                "fees_approved_useNumber",
                                              ])
                                                ? _c("span", [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.usedNumber
                                                      )
                                                    ),
                                                  ])
                                                : _c(
                                                    "span",
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "70px",
                                                        },
                                                        attrs: {
                                                          type: "number",
                                                          size: "small",
                                                          min: 0,
                                                          max: 10000,
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .usedNumber,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "usedNumber",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.usedNumber",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Tiền phải trả",
                                      align: "right",
                                      width: "130",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatCurrencyNew")(
                                                      scope.row.money
                                                    )
                                                  )
                                                ),
                                              ]),
                                              scope.row.fnPackageKidsExtend !=
                                                null &&
                                              scope.row.fnPackageKidsExtend
                                                .active
                                                ? _c(
                                                    "el-tooltip",
                                                    {
                                                      attrs: {
                                                        effect: "dark",
                                                        content:
                                                          scope.row
                                                            .moneyExtend > 0
                                                            ? "Số tiền tăng: " +
                                                              scope.row
                                                                .moneyExtend +
                                                              " đ"
                                                            : "Số tiền giảm: " +
                                                              scope.row
                                                                .moneyExtend +
                                                              " đ",
                                                        placement: "top",
                                                      },
                                                    },
                                                    [
                                                      scope.row.moneyExtend > 0
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-top",
                                                            staticStyle: {
                                                              color: "#409eff",
                                                              "font-size":
                                                                "18px",
                                                            },
                                                          })
                                                        : scope.row
                                                            .moneyExtend < 0
                                                        ? _c("i", {
                                                            staticClass:
                                                              "el-icon-bottom",
                                                            staticStyle: {
                                                              color: "#f56c6c",
                                                              "font-size":
                                                                "18px",
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  )
                                                : _vm._e(),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Tiền đã trả",
                                      align: "right",
                                      width: "110",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("formatCurrencyNew")(
                                                      scope.row.paid
                                                    )
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "description",
                                      label: "Mô tả",
                                      "min-width": "200",
                                    },
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      fixed: "right",
                                      width: "65",
                                      align: "center",
                                      label: "Duyệt",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  disabled:
                                                    scope.row.showNumber == 0 ||
                                                    scope.row.price == 0 ||
                                                    scope.row.usedNumber !=
                                                      scope.row.showNumber ||
                                                    scope.row.locked ||
                                                    scope.row.paid > 0 ||
                                                    !_vm.checkPermission([
                                                      "fees_approved_approved",
                                                    ]),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.approvedKidsPackageOneMethod(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.approved,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "approved",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.approved",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      fixed: "right",
                                      width: "65",
                                      align: "center",
                                      label: "Khóa",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("el-checkbox", {
                                                attrs: {
                                                  disabled:
                                                    !_vm.checkPermission([
                                                      "fees_approved_locked",
                                                    ]),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    return _vm.lockedKidsPackageMethod(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: scope.row.locked,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      scope.row,
                                                      "locked",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "scope.row.locked",
                                                },
                                              }),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                  _c("el-table-column", {
                                    attrs: {
                                      label: "Tác vụ",
                                      fixed: "right",
                                      width: "170",
                                      align: "center",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              scope.row.approved ||
                                              scope.row.locked ||
                                              scope.row.paid > 0 ||
                                              scope.row.price == 0 ||
                                              !_vm.checkPermission([
                                                "fees_approved_useNumber",
                                              ])
                                                ? _c("span", [
                                                    scope.row.paid > 0
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "Không thể sửa"
                                                          ),
                                                        ])
                                                      : scope.row.locked
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "Đã khóa, có thể sửa"
                                                          ),
                                                        ])
                                                      : scope.row.approved
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "Đã duyệt, có thể sửa"
                                                          ),
                                                        ])
                                                      : scope.row.price == 0
                                                      ? _c("span", [
                                                          _vm._v(
                                                            "Đơn giá bằng 0"
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                  ])
                                                : _c(
                                                    "span",
                                                    [
                                                      scope.row.showNumber ==
                                                      scope.row.calculateNumber
                                                        ? _c("el-button", {
                                                            attrs: {
                                                              disabled: "",
                                                              type: "primary",
                                                              size: "mini",
                                                              icon: "el-icon-d-arrow-right",
                                                            },
                                                          })
                                                        : _c(
                                                            "el-tooltip",
                                                            {
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  "Sử dụng số dự toán",
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c("el-button", {
                                                                attrs: {
                                                                  type: "primary",
                                                                  size: "mini",
                                                                  icon: "el-icon-d-arrow-right",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.transferNumberOneMethod(
                                                                        scope.row
                                                                      )
                                                                    },
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                      scope.row.usedNumber !=
                                                        0 &&
                                                      scope.row.usedNumber ==
                                                        scope.row.showNumber
                                                        ? _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                disabled: "",
                                                                size: "mini",
                                                                type: "success",
                                                              },
                                                            },
                                                            [_vm._v("Đã lưu")]
                                                          )
                                                        : _c(
                                                            "el-button",
                                                            {
                                                              attrs: {
                                                                size: "mini",
                                                                type: "success",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.saveUsedNumberOneMethod(
                                                                      scope.row
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("Lưu số")]
                                                          ),
                                                    ],
                                                    1
                                                  ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    align: "center",
                    width: "55",
                    fixed: "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    type: "index",
                    label: "STT",
                    width: "50",
                    align: "center",
                    fixed: "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    "min-width": "145",
                    prop: "fullName",
                    label: "Họ tên",
                    fixed: "",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Ngày sinh",
                    "min-width": "110",
                    align: "center",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm._f("formatDate")(scope.row.birthDay))
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    "min-width": "115",
                    label: "Còn lại thu",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", { staticClass: "high-light" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrencyNew")(
                                  scope.row.totalMoneyRemainIn
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    "min-width": "115",
                    label: "Còn lại chi",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", { staticClass: "high-light" }, [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrencyNew")(
                                  scope.row.totalMoneyRemainOut
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    "min-width": "115",
                    label: "Dự toán thu",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrencyNew")(
                                  scope.row.totalMoneyIn
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "right",
                    "min-width": "115",
                    label: "Dự toán chi",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm._f("formatCurrencyNew")(
                                  scope.row.totalMoneyOut
                                )
                              )
                            ),
                          ]),
                        ]
                      },
                    },
                  ]),
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "approvedNumber",
                    width: "80",
                    label: "Đã duyệt",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    align: "center",
                    prop: "lockedNumber",
                    width: "80",
                    label: "Đã khóa",
                  },
                }),
                _c("el-table-column", {
                  attrs: {
                    label: "Tác vụ",
                    width: "230",
                    align: "center",
                    fixed: "right",
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function (scope) {
                        return [
                          scope.row.fnKidsPackageList.length > 0
                            ? _c(
                                "span",
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "primary" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.detialApprovedKidsMethod(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Mở rộng\n              ")]
                                  ),
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { size: "mini", type: "warning" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.addPackageKidsMethod(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("Thêm")]
                                  ),
                                  scope.row.expandRow
                                    ? _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "mini",
                                            type: "success",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toogleExpandDetailDate(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass:
                                              "el-icon-remove-outline",
                                          }),
                                        ]
                                      )
                                    : _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            type: "success",
                                            size: "mini",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.toogleExpandDetailDate(
                                                scope.row
                                              )
                                            },
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-circle-plus",
                                          }),
                                        ]
                                      ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      },
                    },
                  ]),
                }),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticStyle: { float: "right", margin: "15px 0" } },
          [
            _vm.checkPermission(["fees_approved_useNumber"])
              ? _c(
                  "el-button",
                  {
                    staticClass: "button-bottom",
                    attrs: {
                      type: "success",
                      loading: _vm.loaddingButtonTranferNumber,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.transferNumberManyMethod()
                      },
                    },
                  },
                  [_vm._v("\n        Sử dụng số dự toán\n      ")]
                )
              : _vm._e(),
            _vm.checkPermission(["fees_approved_useNumber"])
              ? _c(
                  "el-button",
                  {
                    staticClass: "button-bottom",
                    attrs: {
                      type: "success",
                      loading: _vm.loaddingButtonSaveNumber,
                    },
                    on: {
                      click: function ($event) {
                        return _vm.saveUseNumberManyMethod()
                      },
                    },
                  },
                  [_vm._v("\n        Lưu số\n      ")]
                )
              : _vm._e(),
            _vm.checkPermission(["fees_approved_approved"]) ||
            _vm.checkPermission(["fees_approved_locked"])
              ? _c(
                  "el-dropdown",
                  { on: { command: _vm.handleCommandMethod } },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "button-bottom",
                        attrs: { type: "success" },
                      },
                      [
                        _vm._v("\n          Tác vụ\n          "),
                        _c("i", { staticClass: "el-icon-caret-bottom" }),
                      ]
                    ),
                    _c(
                      "el-dropdown-menu",
                      { attrs: { slot: "dropdown" }, slot: "dropdown" },
                      [
                        _vm.checkPermission(["fees_approved_approved"])
                          ? _c(
                              "el-dropdown-item",
                              { attrs: { command: "approvedCommand" } },
                              [_vm._v("Duyệt")]
                            )
                          : _vm._e(),
                        _vm.checkPermission(["fees_approved_approved"])
                          ? _c(
                              "el-dropdown-item",
                              { attrs: { command: "unApprovedCommand" } },
                              [_vm._v("Bỏ duyệt")]
                            )
                          : _vm._e(),
                        _vm.checkPermission(["fees_approved_locked"])
                          ? _c(
                              "el-dropdown-item",
                              { attrs: { command: "lockedCommand" } },
                              [_vm._v("Khóa")]
                            )
                          : _vm._e(),
                        _vm.checkPermission(["fees_approved_locked"])
                          ? _c(
                              "el-dropdown-item",
                              { attrs: { command: "unLockedCommand" } },
                              [_vm._v("Bỏ khóa")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("PackageKidsApprovedRapid", {
        ref: "PackageKidsApprovedRapid",
        attrs: { dialogVisible: _vm.showApprovedRapid },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeApprovedRapidDialog()
          },
        },
      }),
      _c("PackageKidsApprovedKidDialog", {
        ref: "PackageKidsApprovedKidDialog",
        attrs: { dialogVisible: _vm.showDetialApprovedDialog },
        on: {
          "dialog-close": function ($event) {
            return _vm.closeDetialApprovedDialog()
          },
        },
      }),
      _c("PackageKidsAddDialog", {
        ref: "PackageKidsAddDialog",
        attrs: { dialogVisible: _vm.showAddPackageKids },
        on: {
          "dialog-close": function ($event) {
            return _vm.dialogCloseAddPackageKidsMethod()
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }